module.exports = __webpack_public_path__ + "img/BPI.79ced9d7.svg";